export class CloseAndRefreshDto {
    Close: boolean;
    Refresh: boolean;
}


// WEBPACK FOOTER //
// ./src/app/data/framework/closeAndRefreshDto.ts